import { useEffect } from 'react'
import Modal from 'antd/lib/modal'
import * as workspaceApi from '../../../services/api/workspace'
import useWorkspaceSwitcher from '../../../hooks/useWorkspaceSwitcher'

const WORKSPACE_REMOVAL_NOTICE_KEY = 'workspaceRemovalNotice'
const LAST_ACTIVE_WORKSPACE_KEY = 'lastKnownActiveWorkspaceUuid'
const LAST_ACTIVE_WORKSPACE_TYPE_KEY = 'lastKnownActiveWorkspaceType'

const readNotice = () => {
  try {
    // eslint-disable-next-line no-undef
    const raw = localStorage.getItem(WORKSPACE_REMOVAL_NOTICE_KEY)
    if (!raw) return null
    return JSON.parse(raw)
  } catch (_) {
    return null
  }
}

const WorkspaceRemovalNotice = () => {
  const { workspaces } = useWorkspaceSwitcher()

  useEffect(() => {
    if (!workspaces.length) return
    const notice = readNotice()
    if (!notice) return
    // eslint-disable-next-line no-undef
    localStorage.removeItem(WORKSPACE_REMOVAL_NOTICE_KEY)
    const fallbackWorkspace = workspaces.find(ws => ws.uuid === notice.fallbackWorkspaceUuid) || workspaces.find(ws => ws.type === 'personal') || workspaces[0]
    const fallbackWorkspaceUuid = fallbackWorkspace?.uuid
    if (!fallbackWorkspaceUuid) return
    Modal.warning({
      title: 'Removed from organization',
      content: 'You were removed from this organization.',
      okText: 'Switch to personal workspace',
      onOk: async () => {
        try {
          await workspaceApi.switchWorkspace({ workspaceUuid: fallbackWorkspaceUuid })
        } catch (_) {}
        // eslint-disable-next-line no-undef
        localStorage.setItem('activeWorkspaceOverride', fallbackWorkspaceUuid)
        // eslint-disable-next-line no-undef
        localStorage.setItem('activeWorkspaceOverrideType', fallbackWorkspace.type || '')
        // eslint-disable-next-line no-undef
        localStorage.setItem(LAST_ACTIVE_WORKSPACE_KEY, fallbackWorkspaceUuid)
        // eslint-disable-next-line no-undef
        localStorage.setItem(LAST_ACTIVE_WORKSPACE_TYPE_KEY, fallbackWorkspace.type || '')
        // eslint-disable-next-line no-undef
        window.location.href = '/dashboard'
      }
    })
  }, [workspaces])

  return null
}

export default WorkspaceRemovalNotice
